export default "__VITE_ASSET__DPnet8V4__"